import React from "react";

export function Dialog({ children }) {
  return <div>{children}</div>;
}

export function DialogTrigger({ children }) {
  return <button>{children}</button>;
}

export function DialogContent({ children }) {
  return <div>{children}</div>;
}

export function DialogHeader({ children }) {
  return <div>{children}</div>;
}

export function DialogTitle({ children }) {
  return <h2>{children}</h2>;
}

export function DialogDescription({ children }) {
  return <p>{children}</p>;
}